import SEO from "components/Seo";
import useTranslation from "next-translate/useTranslation";
import { FaqsLayoutProps } from "pages/help/faqs";
import { PropsWithChildren } from "react";
import FaqSidebarContent from "../components/Faqs/FaqSidebar/FaqSidebarContent";
import StaticSidebarContent from "../components/Faqs/FaqSidebar/StaticSidebarContent";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";
import useLastPath from "../customHooks/useLastPath";
// faqs section nestted layout
const FaqsLayout: React.FC<PropsWithChildren<FaqsLayoutProps>> = (props) => {
  const allFaqs = props.faqs;
  const lastPath = useLastPath();
  const faqs = props.faqs?.find((f) => f.key === lastPath);
  const faqsSidebarContent = (
    <FaqSidebarContent allFaqs={allFaqs} lastPath={lastPath} />
  );
  const paths = [
    { path: "faqs", name: "faqs" },
    { path: "terms", name: "terms" },
    { path: "privacy", name: "privacy" },
    { path: "contact-us", name: "contact_us" },
    { path: "#chat-with-support", name: "support_team" },
  ];

  const staticContent = paths.map((path) => {
    return {
      content: props.pages?.find((page) => page.slug === path.name) || {
        title: path.name,
        description: path.name,
        body: path.name,
      },
      path,
    };
  });
  const staticSidebarContent = (
    <StaticSidebarContent content={staticContent} lastPath={lastPath} />
  );

  const { t } = useTranslation("common");
  return (
    <>
      <SEO
        title={lastPath === "faqs" ? t("faqs") : faqs?.name}
        description={lastPath === "faqs" ? t("faqs_desc") : faqs?.description}
      />
      <div className="cs-sidebar-enabled pt-2 pt-sm-0 h-100">
        <div className="container-fluid px-0 container-md px-md-4 overflow-hidden h-100">
          <div className="row h-100">
            <div className="cs-sidebar col-lg-3 pt-lg-4 d-none d-lg-block px-4  ">
              {/* {faqsSidebarContent} */}
              <div className="">{staticSidebarContent}</div>
            </div>
            <div className="col-lg-9 cs-content pt-lg-0">
              <div className="d-flex align-items-center">
                <CustomJumbotron
                  title={lastPath === "faqs" ? t("faqs") : faqs?.name}
                  desc={
                    lastPath === "faqs" ? t("faqs_desc") : faqs?.description
                  }
                  p="py-4 px-0 px-4 px-lg-0"
                  breadCrumbM="my-0"
                  m="mt-0"
                  className="mt-0 border-bottom"
                  customBreadCrumbs={
                    <CustomBreadCrumbs
                      transformedLabel={(label) => {
                        if (faqs?.key === label) {
                          return t(faqs?.name || label);
                        }
                        return t(label);
                      }}
                    />
                  }
                />
              </div>
              <div className="container px-0 px-md-0"> {props.children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqsLayout;
